(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9931],{

/***/ 31549:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var app_hooks_lang__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91289);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);



var useMetaDescription = function useMetaDescription() {
  var t = (0,app_hooks_lang__WEBPACK_IMPORTED_MODULE_1__/* .useTranslate */ .q)();
  return function (text) {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
      name: "description",
      content: text || t("meta.description")
    });
  };
};

/* harmony default export */ __webpack_exports__["Z"] = (useMetaDescription);

/***/ }),

/***/ 16981:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(50029);
/* harmony import */ var _data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var app_store_slices_user__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(38886);
/* harmony import */ var app_store_store__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4062);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var app_components_icons_Loader__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(37387);
/* harmony import */ var _spotify_module_scss__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(88899);
/* harmony import */ var _spotify_module_scss__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_spotify_module_scss__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var services_hooks_services__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(46725);
/* harmony import */ var app_hooks_lang__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(91289);
/* harmony import */ var app_hooks_navigation_hook__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26793);
/* harmony import */ var app_utils_getMetaDescription__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(31549);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(85893);
















var Spotify = function Spotify() {
  var _session$user2;

  var navigatePath = (0,app_hooks_navigation_hook__WEBPACK_IMPORTED_MODULE_8__/* .useNavigatePath */ .xQ)();
  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_6__.useRouter)();
  var _router$query = router.query,
      code = _router$query.code,
      spotifyError = _router$query.spotifyError;
  var dispatch = (0,app_store_store__WEBPACK_IMPORTED_MODULE_2__/* .useAppDispatch */ .TL)();

  var _useAppSelector = (0,app_store_store__WEBPACK_IMPORTED_MODULE_2__/* .useAppSelector */ .CG)(app_store_slices_user__WEBPACK_IMPORTED_MODULE_1__/* .selectUserState */ .tH),
      session = _useAppSelector.session;

  var getMetaDescription = (0,app_utils_getMetaDescription__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)();
  console.log({
    session: session,
    code: code,
    spotifyError: spotifyError
  });
  (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function () {
    var _session$user;

    if (session !== null && session !== void 0 && (_session$user = session.user) !== null && _session$user !== void 0 && _session$user.spotify_connect) {
      navigatePath("/settings");
    }
  }, [session === null || session === void 0 ? void 0 : (_session$user2 = session.user) === null || _session$user2 === void 0 ? void 0 : _session$user2.spotify_connect]);

  var sendRequest = /*#__PURE__*/function () {
    var _ref = (0,_data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)( /*#__PURE__*/_data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
      var data;
      return _data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!code) {
                _context.next = 14;
                break;
              }

              _context.prev = 1;
              _context.next = 4;
              return (0,services_hooks_services__WEBPACK_IMPORTED_MODULE_7__/* .postPillowUserV2UsersMeSpotify */ .Xw)({
                spotify_code: code,
                redirect_uri: "".concat(window.location.origin, "/spotify/")
              });

            case 4:
              data = _context.sent;

              if (data) {
                dispatch(app_store_slices_user__WEBPACK_IMPORTED_MODULE_1__/* .userActions.setUser */ .hI.setUser(data.data.data));
              }

              _context.next = 11;
              break;

            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](1);
              console.log("ERROR");

            case 11:
              _context.prev = 11;
              navigatePath("/settings");
              return _context.finish(11);

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 8, 11, 14]]);
    }));

    return function sendRequest() {
      return _ref.apply(this, arguments);
    };
  }();

  (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function () {
    var _session$user3;

    if (!spotifyError && code && session !== null && session !== void 0 && session.user && !(session !== null && session !== void 0 && (_session$user3 = session.user) !== null && _session$user3 !== void 0 && _session$user3.spotify_connect)) {
      console.log("SEND REQUEST");
      sendRequest();
    }
  }, [code, spotifyError, session === null || session === void 0 ? void 0 : session.user]);
  var t = (0,app_hooks_lang__WEBPACK_IMPORTED_MODULE_12__/* .useTranslate */ .q)();
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
    className: (_spotify_module_scss__WEBPACK_IMPORTED_MODULE_13___default().container),
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_3___default()), {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("title", {
        children: "Spotify - Radioline"
      }), getMetaDescription(t("settings.meta-description"))]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
      className: (_spotify_module_scss__WEBPACK_IMPORTED_MODULE_13___default().wrapper),
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(app_components_icons_Loader__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {})
    })]
  });
};

/* harmony default export */ __webpack_exports__["default"] = (Spotify);

/***/ }),

/***/ 1819:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/spotify",
      function () {
        return __webpack_require__(16981);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 88899:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"progressColorPrimaryMuted":"rgba(0,0,0,0)","progressColorFill":"#ffca41","progressColorPrimary":"#ffca41","contentMaxWidth":"192rem","wrapper":"spotify_wrapper__Ip009"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(1819); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);